import type { ISerialize } from '@/objects/ISerialize';

export class SignalrContestantImportStatusSubscribeParameters implements ISerialize {
    public ImportGuid: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { ImportGuid?: string | null }) {
        this.ImportGuid = values.ImportGuid ?? '';
    }

    public serialize(): string {
        return '{' + `"ImportGuid": ${JSON.stringify(this.ImportGuid)}` + '}';
    }

    /**
     * Creates an instance of SignalrContestantImportStatusSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { ImportGuid?: string | null }): SignalrContestantImportStatusSubscribeParameters {
        return new SignalrContestantImportStatusSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrContestantImportStatusSubscribeParameters {
        return new SignalrContestantImportStatusSubscribeParameters({ ImportGuid: json.ImportGuid ?? '' });
    }

    /**
     * Creates an instance of SignalrContestantImportStatusSubscribeParameters from another instance of SignalrContestantImportStatusSubscribeParameters.
     * @param other The SignalrContestantImportStatusSubscribeParameters you want to clone
     * @returns A cloned SignalrContestantImportStatusSubscribeParameters
     */
    public static FromOther(other: SignalrContestantImportStatusSubscribeParameters): SignalrContestantImportStatusSubscribeParameters {
        return SignalrContestantImportStatusSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrContestantImportStatusSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrContestantImportStatusSubscribeParameters';
}
